export default __webpack_public_path__ + "static/media/2095-00.062027c7.jpg";